import { AutogenLayoutRateConfirmationViewer } from "./autogen/AutogenLayoutRateConfirmationViewer";
import {  DataDisplayEvent,  ClickEvent } from "@mcleod/components";

export class RateConfirmationViewer extends AutogenLayoutRateConfirmationViewer {

}
